import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _AnalyticsProxy;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { startTransition } from 'react';
import pixall from './pixall';
import googleAnalytics from './googleAnalytics';
import isSSR from '../utils/isSSR';
import clientConfig from '@kbbsdk/config/clientConfig';
import isValidPostMessageOrigin from '../utils/isValidPostMessageOrigin';
import { getAnalyticsMessage } from './utils/googleAnalytics/getAnalyticsMessage';
import StateManager from '../common/managers/StateManager';
import getOptionalValue from '../utils/getOptionalValue';
import { isFlipperOn } from '../utils/flipperExtensions';
var AnalyticsProxy = function (_StateManager) {
  function AnalyticsProxy() {
    var _this;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$instanceId = _ref.instanceId,
      instanceId = _ref$instanceId === void 0 ? AnalyticsProxy.InstanceId : _ref$instanceId,
      _ref$pathToData = _ref.pathToData,
      pathToData = _ref$pathToData === void 0 ? '__ANALYTICS_PROXY_CONFIG__' : _ref$pathToData;
    _classCallCheck(this, AnalyticsProxy);
    _this = _callSuper(this, AnalyticsProxy, [{
      instanceId: instanceId,
      pathToData: pathToData
    }]);
    _defineProperty(_this, "initialized", false);
    _defineProperty(_this, "isFirstLoad", false);
    _defineProperty(_this, "currentWindow", null);
    _defineProperty(_this, "lastTimestamp", null);
    _defineProperty(_this, "currentSection", null);
    _defineProperty(_this, "targets", {});
    _defineProperty(_this, "queue", []);
    _defineProperty(_this, "getSerializableData", function () {
      return {
        lastTimestamp: _this.lastTimestamp
      };
    });
    _defineProperty(_this, "getSerializedScript", function () {
      return Object.keys(_this.currentWindow).map(function (entry) {
        return "\n      window.".concat(entry, " = window.").concat(entry, " || ").concat(JSON.stringify(_this.currentWindow[entry]), ";\n    ");
      }).join('\n');
    });
    _defineProperty(_this, "getHeadScriptContent", function () {
      return "";
    });
    _defineProperty(_this, "getHeadScript", function () {
      return "";
    });
    _defineProperty(_this, "onDOMPageReady", function () {
      if (window.getDataLayer && window.getDataLayer()) {
        _this.onPageReady(window.getDataLayer());
      }
    });
    _defineProperty(_this, "onMessage", function (event) {
      if (!isValidPostMessageOrigin(event.origin)) {
        return;
      }
      var analyticsEvent = getAnalyticsMessage(event);
      if (analyticsEvent) {
        _this.push(function () {
          return analyticsEvent;
        });
      }
    });
    _this.initialized = !isSSR() && window.getDataLayer && window.getDataLayer() && window.getDataLayer().isReady;
    _this.isFirstLoad = isSSR() || !getOptionalValue(window, _this.pathToData);
    _this.currentWindow = !isSSR() ? window : {};
    if (clientConfig.enableGoogleAnalytics) {
      _this.targets.googleAnalytics = googleAnalytics;
    }
    if (clientConfig.enableInlinePixall) {
      _this.targets.pixall = pixall;
    }
    if (!isSSR()) {
      Object.assign(_this, getOptionalValue(window, _this.pathToData) || {});
    }
    Object.keys(_this.targets).forEach(function (targetName) {
      var target = _this.targets[targetName];
      if (target && target.initialize) {
        target.initialize(_this.currentWindow);
      }
    });
    if (!isSSR()) {
      _this.onDOMPageReady();
      document.body.addEventListener('DataLayerReady', _this.onDOMPageReady);
      window.addEventListener('message', _this.onMessage);
      document.body.addEventListener('ForcePageView', _this.onDOMPageReady);
    }
    return _this;
  }
  _inherits(AnalyticsProxy, _StateManager);
  return _createClass(AnalyticsProxy, [{
    key: "getScriptTag",
    value: function getScriptTag() {
      if (isSSR()) {
        return "\n        <script>\n          // Analytics Queues\n          window.".concat(this.pathToData, " = ").concat(JSON.stringify(this.getSerializableData()), ";\n          ").concat(this.getSerializedScript(), "\n        </script>\n      ");
      }
    }
  }, {
    key: "onPageReady",
    value: function onPageReady(dataLayer) {
      if (dataLayer.isReady && this.lastTimestamp !== dataLayer.timestamp) {
        var isFirstLoad = this.isFirstLoad;
        var pixallPageView = {
          pixall: {
            isInitialLoad: isFirstLoad
          }
        };
        this.push(function () {
          return _objectSpread(_objectSpread({
            type: "pageView"
          }, !!(dataLayer !== null && dataLayer !== void 0 && dataLayer.excludePixallPageCall) ? {} : pixallPageView), {}, {
            googleAnalytics: {}
          });
        });
      }
      this.evaluateQueue(dataLayer);
      this.lastTimestamp = dataLayer.timestamp;
      this.initialized = true;
      this.isFirstLoad = false;
    }
  }, {
    key: "evaluateQueue",
    value: function evaluateQueue(dataLayer) {
      var _this2 = this;
      var queue = this.queue;
      this.queue = [];
      queue.forEach(function (dataFn) {
        try {
          _this2.submitData(dataFn, dataLayer);
        } catch (err) {
          console.error(err);
        }
      });
    }
  }, {
    key: "submitData",
    value: function submitData(dataFn, dataLayer) {
      var currentWindow = this.currentWindow,
        targets = this.targets;
      var config = dataFn(dataLayer);
      var _ref2 = dataLayer || {},
        flippers = _ref2.flippers;
      var isUseStartTransition = isFlipperOn(flippers, 'global-analytics-start-transition') || (config === null || config === void 0 ? void 0 : config.useStartTransition);
      var pushData = function pushData() {
        Object.keys(config).forEach(function (targetName) {
          var target = targets[targetName];
          if (target && target[config.type]) {
            target[config.type](currentWindow, dataLayer, config[targetName], config);
          }
        });
      };
      if (isUseStartTransition) {
        startTransition(function () {
          pushData();
        });
      } else {
        pushData();
      }
    }
  }, {
    key: "push",
    value: function push(dataFn) {
      if (!this.initialized) {
        this.queue.push(dataFn);
      } else {
        this.submitData(dataFn, getDataLayer());
      }
    }
  }]);
}(StateManager);
_AnalyticsProxy = AnalyticsProxy;
_defineProperty(AnalyticsProxy, "InstanceId", 'AnalyticsProxy');
_defineProperty(AnalyticsProxy, "getInstance", function (context) {
  return StateManager.getInstance(_AnalyticsProxy, context);
});
export { AnalyticsProxy as default };